import { Dialog } from './overlays/Dialog'

export function ModalShell(props) {
  return <Dialog {...props} />
}
